import axios from "axios";
import store from "@/store";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = store.state.auth?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.common.Authorization;
    }
    return config;
  },

  (error) => Promise.reject(error)
);

instance.interceptors.response.use(null, async (error) => {
  //Si se detecta que el token ya no esta autorizado, se desloguea
  //y se redirige a Login para que se loguee de vuelta
  if (
    error.response.data === "Unauthorized." &&
    error.response.status === 401
  ) {
    store.dispatch(`auth/logout`);
    
  }
  throw error;
});

if (process.env.VUE_APP_MOCKS === "true") {
  const isParamsEqual = (mockParams, requestParams) =>
    Object.keys(mockParams)
      .map((key) => isEqual(mockParams[key], requestParams[key]))
      .every(Boolean);

  const headerIsEqual = (object, header) =>
    Object.keys(object)
      .map((key) => object[key] === header.get(key))
      .every(Boolean);

  // El body puede ser un FormData, en ese caso lo convertimos a objeto normal
  // Esta función solo compara los campos del payload del mock
  const isPayloadEqual = (payload, body) => {
    if (body instanceof FormData) {
      const newBody = {};

      /* eslint-disable */
      for (const [key, value] of body.entries()) {
        newBody[key.replace("[]", "")] = key.includes("[]")
          ? body.getAll(key)
          : value;
      }

      body = newBody;
    }

    return Object.keys(payload)
      .map((key) => isEqual(payload[key], body[key]))
      .every(Boolean);
  };

  const testMock = (request) => {
    let abort = false;
    if (window.mockRequests) {
      let body = null;
      let status = null;
      window.mockRequests.forEach((mockRequest) => {
        if (
          !abort &&
          mockRequest.url.replace(/^\//, "") ===
            request.url.replace(/^\//, "") &&
          mockRequest.method.toLowerCase() === request.method.toLowerCase() &&
          (!mockRequest.params ||
            isParamsEqual(mockRequest.params, request.params)) &&
          (!mockRequest.payload ||
            isPayloadEqual(mockRequest.payload, request.data)) &&
          (!mockRequest.headers ||
            headerIsEqual(mockRequest.headers, request.headers))
        ) {
          abort = true;

          body = cloneDeep(mockRequest.body || {});
          status = mockRequest.status;

          if (mockRequest.validate) {
            const result = mockRequest.validate(request);
            body = Object.assign(result.body);
            if (mockRequest.method === "POST" && !body.id) body.id = 97; // id de ejemplo
            status = result.status;
          } else if (typeof mockRequest.body === "function") {
            body = mockRequest.body(request);
          }
          const { data, url, method, headers } = request;
          const req = { data, url, method, headers };

          console.log(req, body, status);
        }
      });
      if (body) return { ...body, status };
    }

    return abort;
  };
  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const files = require.context("../../mocks", true, /mock\.js$/);
  window.mockRequests = [];
  files.keys().forEach((key) => {
    window.mockRequests = window.mockRequests.concat(files(key).default);
  });

  instance.interceptors.request.use((config) => {
    throw new axios.Cancel(config);
  });
  instance.interceptors.response.use(null, async (error) => {
    await delay(700);
    const response = testMock(error.message);
    if (response) return response;
    if (error.message.url !== "/login") alert("MOCK NO IMPLEMENTADO");
    throw "an error occurred";
  });
}
export default instance;
